import { useId, useState } from "react";

import { Icon } from "@/design-system";

export default function FilterSection({
  title,
  summary = "",
  onClear,
  clearAriaLabel = `Clear ${title.toLowerCase()} filter`,
  defaultOpen = true,
  bordered = true,
  children,
  className = "",
  contentClassName = "",
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const contentId = useId();

  return (
    <section
      className={`${bordered ? "border-t border-line-subtle " : ""}px-[var(--space-2)] pb-[10px] pt-[4px] ${className}`}
    >
      <div className="relative rounded-sm [transition:background_var(--duration-fast)] hover:bg-neutral-100">
        <button
          type="button"
          className="flex w-full min-w-0 items-center gap-[4px] border-0 bg-transparent py-[7px] pl-[8px] pr-[8px] text-left font-sans focus-visible:outline-none focus-visible:[box-shadow:var(--focus-ring)]"
          onClick={() => setIsOpen((open) => !open)}
          aria-expanded={isOpen}
          aria-controls={contentId}
        >
          <span
            className={`flex min-w-0 flex-col items-start gap-[1px] ${summary && onClear ? "pr-[22px]" : ""}`}
          >
            <span className="text-2xs font-bold uppercase tracking-[var(--tracking-wider)] text-ink-3">
              {title}
            </span>
            {summary && (
              <span className="max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-2xs font-semibold text-orange-600">
                {summary}
              </span>
            )}
          </span>
          <Icon
            name="expand_more"
            size={18}
            weight={400}
            className={`ml-auto shrink-0 text-ink-3 [transition:transform_var(--duration-base)_var(--ease-spring)] ${isOpen ? "rotate-180" : ""}`}
          />
        </button>

        {summary && onClear && (
          <button
            type="button"
            onClick={onClear}
            aria-label={clearAriaLabel}
            title={clearAriaLabel}
            className="absolute right-[27px] top-1/2 inline-flex h-[18px] w-[18px] -translate-y-1/2 items-center justify-center rounded-full border-0 bg-transparent text-ink-3 [transition:background_var(--duration-fast),color_var(--duration-fast),transform_var(--duration-base)_var(--ease-spring)] hover:bg-orange-50 hover:text-orange-600 active:scale-[0.85] focus-visible:outline-none focus-visible:[box-shadow:var(--focus-ring)]"
          >
            <Icon name="close" size={14} weight={400} />
          </button>
        )}
      </div>

      {isOpen && (
        <div id={contentId} className={contentClassName}>
          {children}
        </div>
      )}
    </section>
  );
}
